import {initPlugin, initPlugins, PluginInstance} from "../../lib/plugin";

import '../../plugins'
import { useWsClient } from "../../extension/lib/WsClient";

const config = {
    token: null,
    room: 'little_amyka',
    ws: 'wss://' + location.hostname,
    hearts: {
        enabled: true,
        duration: 2500,
        minSize: 20,
        maxSize: 30,
        horizontalPercent: 20,
        placementTimeout: 50,
        location: 'right',
    }
}

const originalConsole = console

// @ts-ignore
console = {}

for (const method of Object.keys(originalConsole)) {
    console[method] = (...args: any) => {
        if (process.env.NODE_ENV === 'release') {
            return
        }
        return originalConsole[method](...args)
    }
}

let plugins: PluginInstance[] = []

const query = location.href.split('?')[1] || ''
if (query) {
    const queryData = query.split('&').reduce((res, val) => {
        const [ key, value ] = val.split('=')
        res[key] = value
        return res
    }, {})
    if (typeof queryData['token'] !== 'undefined') {
        config.token = queryData['token']
    }
    if (typeof queryData['ws'] !== 'undefined') {
        config.ws = queryData['ws']
    }
}

const ws = useWsClient('client')

ws.onLoggedIn(data => {
  data.enabledPlugins = data.enabledPlugins || {}
  // console.log('adding foo')
    // data.enabledPlugins['foo'] = {
    //     id: 'foobar',
    //     plugin: 'cube',
    //     config: {
    //         enabled: true,
    //         horizontal: 'right',
    //         horizontalSpace: 30,
    //         vertical: 'bottom',
    //         verticalSpace: 0,
    //     }
    // }
    plugins = initPlugins(data.enabledPlugins)
})

ws.onMessage((action, data) => {
    switch (action) {
        case 'plugin-update': {
                const plugin = plugins.find(p => p.id === data.id)
                if (!plugin) {
                    console.error('got config update for unknown plugin', data)
                    break
                }
                plugin.config = data.config
                plugin.onConfig(data.id, data.config)
                console.log('update plugin', plugin)
                break
            }
        case 'plugin-remove': {
                const plugin = plugins.find(p => p.id === data.id)
                if (!plugin) {
                    console.error('got config update for unknown plugin', data)
                    break
                }
                if (typeof plugin.onRemove !== 'undefined'){
                    plugin.onRemove(data.id)
                }
                plugins = plugins.filter(p => p.id !== data.id)
                console.log('removed plugin', plugin)
                break
            }
        case 'plugin-added': {
                plugins.push(initPlugin(data.plugin))
                console.log('added plugin', data.plugin)
                break
            }
        case 'plugin-test-action': {
                const plugin = plugins.find(p => p.id === data.id)
                if (plugin && typeof plugin.testAction[data.actionKey] !== 'undefined') {
                    plugin.testAction[data.actionKey].run(data.data, plugin.config)
                }
                break
            }
        default: {
                for (const plugin of plugins) {
                    console.log('forwarding ws actiion to plugin', plugin.name, data.action, data)
                    if (plugin.onWsAction(data.id, action, data, plugin.config)) {
                        console.log(`action "${data.action} handled by plugin "${plugin.name}"`)
                    }
                }
                break
            }
        }
    }
)

ws.wsConnect(config.token)
